import { randomString } from "@/utils/common"
import _ from "lodash"

/**
 * 获取任务需要填写的字段信息
 * @param taskInfo
 * @param sheetDef
 * @returns {null|{emptyText: string, name: string, tempId, fields: {name: *, _type: (string), control: *, id: *}[]}}
 */
export function getRefDataInfo(taskInfo, sheetDef) {
  if (!sheetDef?.controls?.length) return null
  let controlsMap = _.keyBy(sheetDef.controls, "_cid")
  let cids = taskInfo.taskType.fillCids?.map(i => i.cid).filter(cid => controlsMap[cid]) || []
  if (cids.length == 0) return null
  let fields = cids
    .map(cid => controlsMap[cid])
    .filter(control => !(control._type === "ref" && !control.oneFlag))
    .map(control => ({
      name: control.name,
      id: control._cid,
      _type: control._type,
      control: control
    }))
  return {
    name: "任务成果",
    tempId: randomString(10),
    emptyText: "未填写",
    fields: fields
  }
}
